import { CampaignType } from '../../../../models/AdminModels';

export const getCampaignNames = (campaignType?: CampaignType) => {
	switch (campaignType) {
		case CampaignType.Blog: {
			return { ctaName: 'Post', displayName: 'blog post' };
		}
		case CampaignType.Social: {
			return { ctaName: 'Post', displayName: 'social media post' };
		}
		default: {
			return { ctaName: 'Campaign', displayName: 'campaign' };
		}
	}
};
